(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    try {
      const url = new URL(window.location.href);
      if (url.hash) {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      }
    } catch (e) {}

    // Added by Lance
    const overlay = document.getElementById('pw-overlay');
    const gate = document.getElementById('pw-gate');
    if (!gate) return;

    const expected = gate.dataset.hash || '';
    const key = gate.dataset.key || '';
    const content = document.getElementById('protected-content');
    const form = gate.querySelector('form');
    const input = form ? form.querySelector('input[type="password"]') : null;
    const error = document.getElementById('pw-error');

    function showContent() {
      if (overlay) overlay.style.display = 'none';
      if (content) {
        content.style.display = '';
        content.removeAttribute('aria-hidden');
        content.removeAttribute('inert');
      }
      // Re-run hash scroll after unlocking
      try {
        const u = new URL(window.location.href);
        if (u.hash) {
          const card = document.getElementById(u.hash.slice(1));
          if (card) card.scrollIntoView({ behavior: 'instant' });
        }
      } catch (e) {}
    }

    // If the browser can't hash, show the overlay with an error
    if (!window.crypto || !crypto.subtle || !window.TextEncoder) {
      if (overlay) overlay.style.display = '';
      if (error) {
        error.style.display = 'block';
        error.textContent = 'Your browser cannot unlock this content.';
      }
      return;
    }

    async function sha256Hex(str) {
      const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
      return Array.from(new Uint8Array(buf))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
    }

    // Auto-unlock if previously validated
    try {
      if (key && localStorage.getItem(key) === expected) {
        showContent();
        return; // overlay stays hidden; no text flash
      }
    } catch (e) {}

    // Not unlocked yet → reveal the overlay (which includes the heading + form)
    if (overlay) overlay.style.display = '';

    if (form && input) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const val = (input.value || '').trim();
        if (!val) return;

        try {
          const attempt = await sha256Hex(val);
          if (attempt === expected) {
            try {
              if (key) localStorage.setItem(key, expected);
            } catch (e) {}
            showContent();
          } else {
            if (error) {
              error.style.display = 'block';
              error.textContent = 'Incorrect password. Please try again.';
            }
            input.focus();
            input.select();
          }
        } catch (err) {
          if (overlay) overlay.style.display = '';
          if (error) {
            error.style.display = 'block';
            error.textContent = 'Your browser cannot unlock this content.';
          }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
